import utilities from '../Helpers/utilities';

export class EntityErrorHandler {
    /**
     * Handle errors from entity resolution
     * @param {Error} error - The error object
     */
    static handleError(error) {
        if (error.response || error.status) {
            const status = error.response?.status || error.status;

            switch (status) {
                case 400:
                    this.showInvalidFormatAlert();
                    break;
                case 403:
                    this.showAccessDeniedAlert();
                    break;
                case 404:
                    this.showNotFoundAlert();
                    break;
                default:
                    this.showGenericErrorAlert();
            }
        } else {
            this.showNetworkErrorAlert();
        }
    }

    /**
     * Show snackbar for invalid format
     */
    static showInvalidFormatAlert() {
        this.showAccessDeniedAlert();
    }

    /**
     * Show snackbar for entity not found
     */
    static showNotFoundAlert() {
        this.showAccessDeniedAlert();
    }

    /**
     * Show snackbar for access denied
     */
    static showAccessDeniedAlert() {
        utilities().showErrorSnackbar(
            'We are unable to load that resource. Please check if you have mistyped it, and if you have necessary permissions to view it'
        );
    }

    /**
     * Show snackbar for generic errors
     */
    static showGenericErrorAlert() {
        utilities().showErrorSnackbar(
            'An error occurred while loading the requested item. Please try again.'
        );
    }

    /**
     * Show snackbar for network errors
     */
    static showNetworkErrorAlert() {
        utilities().showErrorSnackbar(
            'Unable to connect to the server. Please check your internet connection and try again.'
        );
    }
}
